import { Injectable } from '@angular/core';
import { HOME_PAGE_CONFIG, getHomePageForUser, setUserHomePage, removeUserHomePage } from '../config/home-page.config';

@Injectable({
  providedIn: 'root',
})
export class HomePageService {
  constructor() {}

  /**
   * Get the home page path for a specific user email
   * Falls back to default home page if user has no custom mapping
   * @param email - The user's email address
   * @returns string - The home page path for this user
   */
  getHomePageForUser(email: string): string {
    return getHomePageForUser(email);
  }

  /**
   * Get the default home page path
   * @returns string - The default home page path
   */
  getDefaultHomePage(): string {
    return HOME_PAGE_CONFIG.defaultHomePath;
  }

  /**
   * Set a custom home page for a user
   * @param email - The email address
   * @param homePath - The home page path
   */
  setUserHomePage(email: string, homePath: string): void {
    setUserHomePage(email, homePath);
  }

  /**
   * Remove a custom home page for a user
   * @param email - The email address
   */
  removeUserHomePage(email: string): void {
    removeUserHomePage(email);
  }

  /**
   * Get all custom home page mappings
   * @returns object - The email to home page mapping
   */
  getAllUserHomepageMappings(): { [email: string]: string } {
    return { ...HOME_PAGE_CONFIG.emailHomepageMap };
  }
}
